import React from "react";
import { FaTimesCircle } from 'react-icons/fa';
import './subscription.css';
import Footer from "../components/Footer/footer";
import DashboardNavbar from "../components/Navbar/navbar-dashboard";
import { useNavigate } from "react-router-dom";

const CancelPageMobile = () =>
{
  const navigate = useNavigate();

  return (
    <>
      <div className="cancel-page">
        <div className="cancel-content">
          <FaTimesCircle className="cancel-icon" />
          <h1>Subscription Canceled</h1>
          <p>We're sorry to see you go! If you have any questions or need assistance, feel free to contact our support team.</p>
          <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <div className="centered-button-container">
                <button
                    className="back-button-mobile"
                    onClick={() => window.location.href = 'buildstartapp://subscription/home'}
                >
                    Return to Build Start App
                </button>
            </div>            
            <p>&nbsp;</p>
            <p>Or <a href="buildstartapp://subscription/home">tap here</a> to return to the Build Start App now.</p>          </div>
      </div>
      <Footer />
    </>
  );
};

export default CancelPageMobile;